import type {
  DisplayLogic,
  QuestionDisplayVariant,
  SkipLogic,
  SurveyQuestion,
} from '../../../../types/survey';
import type { QuestionBeforeLogics } from './questionMapperTypes';

/** Adds skip, display, and variant rules to a mapped question. */
export function attachQuestionLogics(
  question: QuestionBeforeLogics,
  skipLogics: SkipLogic[] | undefined,
  displayLogic: DisplayLogic | undefined,
  displayVariants: QuestionDisplayVariant[] | undefined
): SurveyQuestion {
  return {
    ...question,
    ...(skipLogics?.length ? { skipLogics } : {}),
    ...(displayLogic ? { displayLogic } : {}),
    ...(displayVariants?.length ? { displayVariants } : {}),
  };
}
